import React from 'react';

const Page404 = props => {
	return <div>Ofertas Page</div>;
};

export default Page404;
